export const HeaderNavConstants = {
    ON_COLLAPSED: 'ON_COLLAPSED',
    ON_OPEN: 'ON_OPEN',
    ON_CLOSE: 'ON_CLOSE',
};